/**
 * Redux App Settings Actions
 */
import {
  COLLAPSED_SIDEBAR,
  SHRINK_SIDEBAR,
  SET_COUNTRY,
  SET_LANGUAGE,
  SET_PAGE_HISTORY,
  REMOVE_PAGE_HISTORY,
  REFRESH_MATERIAL,
  COLLAPSED_FIELD_SIDEBAR,
  COLLAPSED_NOTIFICATION_SIDEBAR,
} from './types';

/**
 * Redux Action To Emit Collapse Sidebar
 * @param {*boolean} isCollapsed
 */
export const collapsedSidebarAction = isCollapsed => ({
  type: COLLAPSED_SIDEBAR,
  isCollapsed,
});

export const collapsedFieldSidebarAction = isCollapsed => ({
  type: COLLAPSED_FIELD_SIDEBAR,
  isCollapsed,
});

export const collapsedNotificationSidebarAction = isCollapsed => ({
  type: COLLAPSED_NOTIFICATION_SIDEBAR,
  isCollapsed,
});

export const shrinkSidebarAction = shrinkSidebar => ({
  type: SHRINK_SIDEBAR,
  shrinkSidebar,
});

/**
 * Redux Action To Set Country
 */
export const setCountry = country => ({
  type: SET_COUNTRY,
  payload: country,
});

/**
 * Redux Action To Set Language
 */
export const setLanguage = language => ({
  type: SET_LANGUAGE,
  payload: language,
});

/**
 * Redux Action To Set Page History
 */

export const setPageHistory = (pageHistory, id, data) => dispatch => {
  const payload = {
    ...pageHistory,
    [id]: { ...pageHistory[id], ...data },
  };
  dispatch({ type: SET_PAGE_HISTORY, payload });
  localStorage.setItem('pageHistory', JSON.stringify(payload));
};

export const removePageHistory = () => dispatch => {
  dispatch({ type: REMOVE_PAGE_HISTORY });
  localStorage.removeItem('pageHistory');
};

/**
 * Redux Action To Refrsh Material List
 */
export const refreshMaterial = () => ({
  type: REFRESH_MATERIAL,
});
